// extracted by mini-css-extract-plugin
export default {"column":"column_column__3WKtD","fillSpace":"column_fillSpace__cGwgb"};